const ROUTES = {
  HOME: '/',
  SITE_SEARCH: '/search',
}

export default ROUTES
